// The button row of a transfer sheet, and the width and height of a button in
// it. MOVED here from TransfersPage.js at Session 79.22b.4.4 (#698 half a,
// gate 665 D25), unchanged, because the item-by-item answer now renders in the
// Requests inbox as well as on the Transfers sheet, and it must look and size
// the same in both (locked rule 14: one implementation, not two copies).
import React from 'react';
import { controlHeight } from '../../lib/tiers';

export function Actions({ isMobile, children }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row-reverse',
      // With row-reverse the main axis runs right-to-left, so main-START is the
      // RIGHT edge. flex-end here would pin the row to the LEFT, which is what the
      // first build did and what the screenshot showed.
      justifyContent: isMobile ? undefined : 'flex-start',
      alignItems: isMobile ? 'stretch' : 'center',
      gap: 10,
      flexWrap: 'wrap',
    }}>
      {children}
    </div>
  );
}

// A button in that row: full width on a phone, sized to its label on desktop
// with a floor so a two-word label is still a comfortable target.
//
// ActionButton supplies NO styling of its own — it passes className and style
// straight through — and this page is its FIRST CALLER anywhere in the app, so
// there was no precedent to copy and the first build rendered browser-default
// grey buttons. The app's own classes are `btn` plus a variant, in index.css.
// The 44px floor on mobile is MEASURED, not assumed. `.btn` in index.css is
// `padding: 8px 18px` at 13px, which renders **32px tall** — verified live at
// 375px in this session. Apple's and Android's guidance both put the minimum
// touch target at 44pt/48dp, and 78v caught the identical thing on the email
// button, where a gate claimed it sat "well above" the minimum and it rendered
// 40px.
//
// Raised HERE rather than in index.css deliberately: `.btn` is every button in
// the app, and 32px is the app-wide height on every screen. That is a real
// finding and it is Colby's call, not a thing to change under a transfer build.
//
// 48, not 44 (#581, amended at 79.21b). Every button in this row COMMITS, and
// #417's D2 settled 48px for a committing button with a finger at 79.15 — the
// 44 above was the standard when this was written and was never swept.
// Acceptance line O1 measures these.
// #612, Session 79.22b -- THE COMMIT FLOOR AT EVERY WIDTH, FROM THE POINTER.
// The phone layout always had 48. The desk layout had no minimum at all, so the
// button that routes a refusal drew at 31.5px - under the mouse floor of 32 by
// half a pixel, and nowhere near the 48 a finger needs on a tablet held at desk
// width. controlHeight() is the one source (#417 D6).
export function actionWidth(isMobile, coarse = false) {
  const commit = controlHeight(coarse, 'commit');
  return isMobile
    ? { width: '100%', justifyContent: 'center', minHeight: Math.max(48, commit) }
    : { minWidth: 150, justifyContent: 'center', minHeight: commit };
}
